export default "__VITE_ASSET__BKyZjwTp__"